export var inputReset = function() {
    return {
        outline: 'none',
        border: '0 none',
        background: 'transparent'
    };
};
export var buttonReset = function() {
    return {
        backgroundColor: 'transparent',
        border: '0 none',
        padding: 0,
        margin: 0
    };
};
export var listReset = function(param) {
    var font = param.font;
    return {
        listStyleType: 'none',
        padding: 0,
        margin: 0,
        lineHeight: font.lineHeight.list
    };
};
